export const uk = {
    addMoney: 'Пополнить счет',
    moneyBlocked: 'Средства заблокированы',
    needPayment: 'Деньги на кампании заканчиваются. Необходимо пополнить баланс'
};
